import { NavItemType } from '@/router/type'

const usersRouterItems: NavItemType[] = [
  {
    id: 'users',
    title: 'Usuários',
    icon: 'user',
    type: 'collapse',
    pathname: '/usuario',
    children: [
      {
        id: 'patient',
        title: 'Pacientes',
        url: '/usuario/pacientes',
        type: 'item',
      },
      {
        id: 'clinicAdmin',
        title: 'Admin Clínica',
        url: '/usuario/admin-clinica',
        type: 'item',
      },
      {
        id: 'conexaAdmin',
        title: 'Admin Conexa',
        url: '/usuario/admin-conexa',
        type: 'item',
      },
      {
        id: 'professional',
        title: 'Profissionais',
        url: '/usuario/profissionais',
        type: 'item',
      },
    ],
  },
]

export default usersRouterItems
